module.exports = __webpack_public_path__ + "img/icon-migration-member-red.7d054c7a.svg";